import NumberOfItemsCell from './component';
import { compose, mapProps } from 'recompose';
import { connect } from 'react-redux';

import { withJourneyCardSelectors } from 'modules/journey/card/hoc';

const defaultPalletPerCountry = {
  UK: 'US_PALLET',
};

const palletTypeText = {
  EU_PALLET: 'Eu',
  CUSTOM_PALLET: 'Sp',
  US_PALLET: 'Us',
  MIXED_PALLET: 'Mx',
  equivalent: 'Eq',
};

const DEFAULT_PALLET_TYPE = 'EU_PALLET';

const fields = [
  'type_pallets',
  'real_pallets',
  'max_real_pallets',
  'load_types',
  'equivalent_pallets',
  'max_equivalent_pallets',
  'shipper',
  'stops',
];

const enhance = compose(
  withJourneyCardSelectors,
  connect((state, props) => {
    const {
      real_pallets: realPallets,
      max_real_pallets: maxRealPallets,
      equivalent_pallets: equivalentPallets,
      max_equivalent_pallets: maxEquivalentPallets,
      type_pallets: typePallets,
      load_types: loadTypes,
      shipper,
    } = props.selectors.getJourneyFields(state, props.journeyId, fields);
    const journey = props.selectors.getJourneyFields(state, props.journeyId, fields);

    const { country } = shipper || {};

    return {
      realPallets,
      maxRealPallets,
      equivalentPallets,
      maxEquivalentPallets,
      typePallets,
      loadTypes,
      stops: journey?.stops,
      defaultPallet: (!!country && defaultPalletPerCountry[country]) || DEFAULT_PALLET_TYPE,
    };
  }),
  mapProps(
    ({
      realPallets,
      maxRealPallets,
      maxEquivalentPallets,
      equivalentPallets,
      typePallets,
      loadTypes,
      defaultPallet,
      showMax,
      showEquivalents,
      stops,
    }) => ({
      numberOfItems: showMax ? maxRealPallets : realPallets,
      numberOfItemsEquivalent: showMax ? maxEquivalentPallets : equivalentPallets,
      typePallets,
      loadTypes: loadTypes,
      typeOfPalletsEquivalents: palletTypeText[defaultPallet],
      showEquivalents: showEquivalents && typePallets !== defaultPallet,
      stops,
    })
  )
);

export default enhance(NumberOfItemsCell);
